import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { ToastContainer } from "react-toastify"

import Login from "../pages/login"
import Dashboard from "../pages/dashboard"
import UnprotectedRoute from "../components/unprotected-route"
import ProtectedRoute from "../components/protected-route"

const App = () => {
  return (
    <Router>
      <ToastContainer style={{ zIndex: 99999 }} position="top-right" theme="colored" />
      <Routes>
        <Route
          path="/login"
          element={
            <UnprotectedRoute>
              <Login />
            </UnprotectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  )
}

export default App
